import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { ContinueButton } from 'page/ProfileScreen/BasicSelfiesPanel/ContinueButton'
import { SelfieExamples } from 'page/ProfileScreen/BasicSelfiesPanel/SelfieExamples'
import { RetakeButton } from 'page/ProfileScreen/Selfies/buttons/RetakeButton'
import { TakeButton } from 'page/ProfileScreen/Selfies/buttons/TakeButton'
import { UploadButton } from 'page/ProfileScreen/Selfies/buttons/UploadButton'
import { CameraInput } from 'page/ProfileScreen/Selfies/CameraInput'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const BasicCameraPanel = observer(() => {
  const { picture, selfies, camera } = store.profile.common
  const { seconds } = camera
  const error = selfies.find(it => it.error)?.error
  const errors = !!error
  const canContinue = selfies.some(it => it.url)

  const onUpload = useLatestCallback(() => {
    store.profile.basic.step = 'upload'
  })

  const onContinue = useLatestCallback(async () => {
    store.profile.basic.step = 'second'
  })

  const upload = opt.qr_upload && <UploadButton onUpload={onUpload} />
  const take = <TakeButton />
  const retake = <RetakeButton />
  const next = <ContinueButton disabled={!canContinue} action={onContinue} />

  return (
    <Vertical gap={40} center>
      <CameraInput />

      {!picture && !errors && <SelfieExamples />}

      {!!error && (
        <Typo size={24} center error>
          {error}
        </Typo>
      )}

      {(picture || errors) && opt.basic && (
        <Vertical gap={24} wide>
          <Space gap={24} columns wrap>
            {retake}
            {next}
          </Space>
          {upload}
        </Vertical>
      )}

      {(!picture && !errors) && !seconds && (
        <Vertical gap={24} wide>
          {take}
          {upload}
        </Vertical>
      )}
    </Vertical>
  )
})
